import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../../services/i18n/language';

/** Заголовок страницы кабинета экспедитора — название текущего раздела (сами разделы — в боковом меню). */
@Component({
  selector: 'app-ff-cabinet-head',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cabinet-head.component.html',
  styleUrl: './cabinet-head.component.scss'
})
export class FfCabinetHeadComponent implements OnInit, OnDestroy {
  @Input() titleKey = 'header.personalCabinet';
  @Input() titleFallback = 'Личный кабинет';

  private subscription?: Subscription;

  constructor(
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription = this.languageService.getTranslations().subscribe(() => this.cdr.markForCheck());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  t(key: string, fallback: string): string {
    const value = this.languageService.translate(key);
    return value && value !== key ? value : fallback;
  }
}
